import LogicaAPI from "./logicaapi";

class PaymentMethods extends LogicaAPI {
  async paymentMethods() {
    const params = {
      published: true,
    };
    const res = this.get("/api/v1/payment_methods", {params});
    return res;
  }
}
export default PaymentMethods;
